<template>
  <v-content class="qualification-type page">
    <can I="read" a="QualificationType">
      <v-container>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs class="pl-0"
            :items="[{ exact: true, text: 'Admin', to: '/dashboard' },
                     { exact: true, text: 'Qualification Types', to: '/qualification_types' },
                     { exact: true, text: $route.params.id, to: `/qualification_types/${$route.params.id}` }]">
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />

          <v-btn small flat fab @click="refresh">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <CopyButton />
        </v-toolbar>

        <can v-if="editing" I="edit" a="QualificationType">
          <EditQualificationType
            @refresh="refresh"
            @update="update"
            @cancel="cancel"
          />
        </can>
        <ShowQualificationType
          v-else
          @refresh="refresh"
          @destroy="destroy"
          @edit="editing = true"
        />

        <QualificationComponents
          :qualification-type="{ id: parseInt($route.params.id) }"
        />
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Components
import ShowQualificationType from '@/components/qualification_types/Show'
import EditQualificationType from '@/components/qualification_types/Edit'
import QualificationComponents from '@/components/qualification_components/List'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: {
    ShowQualificationType,
    EditQualificationType,
    QualificationComponents
  },
  created() {
    this.$store.dispatch('admin/qualificationTypes/fetch', this.$route.params.id)
    this.$store.dispatch('admin/qualificationComponents/fetchAll', { qualificationType: { id: this.$route.params.id } })
  },
  data() {
    return { editing: false }
  },
  computed: {
    qualificationType() {
      return this.$store.getters['admin/qualificationTypes/find'](parseInt(this.$route.params.id))
    }
  },
  methods: {
    refresh() {
      this.$store.dispatch('admin/qualificationComponents/fetchAll', {
        qualificationType: { id: this.$route.params.id }
      })
      return this.$store.dispatch('admin/qualificationTypes/fetch', this.$route.params.id)
    },
    cancel() {
      this.refresh().then(() => (this.editing = false))
    },
    update() {
      this.$store
        .dispatch('admin/qualificationTypes/update', {
          id: this.qualificationType.id,
          name: this.qualificationType.name,
          acronym: this.qualificationType.acronym == '' ? null : this.qualificationType.acronym,
          qualificationCategory: { id: this.qualificationType.qualificationCategory.id }
        })
        .then(() => {
          if (!this.qualificationType.errors) {
            this.editing = false
          }
        })
    },
    destroy() {
      this.$store.dispatch('admin/qualificationTypes/destroy', this.$route.params.id).then(
        () => {
          // Success
          this.$store.commit('snackbar', { text: 'Qualification Type deleted', type: 'success' })
          this.$router.push('/qualification_types')
        },
        () => {
          // Failure
          this.$store.commit('snackbar', { text: 'There was a problem deleting the qualification type', type: 'error' })
        }
      )
    }
  }
}
</script>
